/* Keep each vehicle attached to its own cart item, including mixed-vehicle orders. */
window.dmVehicleProperties = function (root) {
  const fields = root.querySelectorAll('[data-vehicle-field]');
  if (!fields.length) return null;
  const properties = {};
  for (const field of fields) {
    field.value = field.value.trim();
    if (!field.reportValidity()) return null;
    if (field.value) properties[field.dataset.vehicleField] = field.value;
  }
  return properties;
};
